import React, { useState } from "react";

export default function AssetTypesGrid() {
	const [searchTerm, setSearchTerm] = useState("");

	const assetTypes = [
		
		{
			id: 2,
			name: "Computer",
			icon: "ki-duotone ki-devices-2",
			count: 1,
			borderColor: "#3b82f6",
		},
		
		{
			id: 4,
			name: "Generic",
			icon: "ki-duotone ki-check-circle",
			count: 7,
			borderColor: "#3b82f6",
		},
		{
			id: 5,
			name: "HMI",
			icon: "ki-duotone ki-chart-simple",
			count: 5,
			borderColor: "#3b82f6",
		},
		{
			id: 7,
			name: "Industrial...",
			icon: "ki-duotone ki-building",
			count: 11,
			borderColor: "#3b82f6",
		},
		{
			id: 8,
			name: "IP Camera",
			icon: "ki-duotone ki-lens",
			count: 1,
			borderColor: "#3b82f6",
		},
		{
			id: 11,
			name: "Network",
			icon: "ki-duotone ki-wifi",
			count: 3,
			borderColor: "#3b82f6",
		},
		{
			id: 12,
			name: "SCADA",
			icon: "ki-duotone ki-devices",
			count: 2,
			borderColor: "#3b82f6",
		},
		{
			id: 13,
			name: "Virtual Devices",
			icon: "ki-duotone ki-cloud",
			count: 30,
			borderColor: "#3b82f6",
		},
		{
			id: 14,
			name: "VoIP",
			icon: "ki-duotone ki-call",
			count: 1,
			borderColor: "#3b82f6",
		},
	];

	const filteredAssets = assetTypes.filter((asset) =>
		asset.name.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<div className="card h-100 bg-secondary mt-4">
			<div className="card-body">
				<div className="d-flex justify-content-between align-items-start mb-4">
					<h5 className="text-white mb-0">
						Asset Types ({assetTypes.length})
					</h5>
					<input
						type="text"
						className="form-control"
						placeholder="Search by name"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						style={{
							width: 200,
							backgroundColor: "#1a1a2e",
							borderColor: "#3a3a52",
							color: "#bfcbdc",
						}}
					/>
				</div>

				<div className="row g-3">
					{filteredAssets.map((asset) => (
						<div
							key={asset.id}
							className="col-lg-2 col-md-3 col-sm-4 col-6"
						>
							<div
								className="card h-100 transition cursor-pointer"
								style={{
									backgroundColor: "#1a1a2e",
									border: `1px solid #2a2a42`,
									borderLeft: `4px solid ${asset.borderColor}`,
									transition: "all 0.3s ease",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.borderLeftColor =
										asset.borderColor;
									e.currentTarget.style.boxShadow =
										"0 4px 20px rgba(59, 130, 246, 0.2)";
									e.currentTarget.style.transform =
										"translateY(-2px)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.borderLeftColor =
										asset.borderColor;
									e.currentTarget.style.boxShadow = "none";
									e.currentTarget.style.transform =
										"translateY(0)";
								}}
							>
								<div className="card-body d-flex align-items-center justify-content-start p-3">
									{/* Icon on the left */}
									<div
										style={{
											
											color: asset.borderColor,
											height: 80,
											width: 80,
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											flexShrink: 0,
											marginRight: 16,
										}}
									>
										<i
											className={asset.icon}
											style={{
												color: asset.borderColor,
                                                fontSize: 50,
											}}
										>
											<span className="path1"></span>
											<span className="path2"></span>
											<span className="path3"></span>
										</i>
									</div>

									{/* Content on the right */}
									<div
										className="d-flex flex-column justify-content-center"
										style={{
											flex: 1,
										}}
									>
										<h6
											className="text-white mb-2"
											style={{
												fontSize: 14,
												fontWeight: 600,
												marginBottom: 4,
											}}
										>
											{asset.name}
										</h6>
										<div
											style={{
												fontSize: 16,
												fontWeight: 600,
												color: asset.borderColor,
												marginBottom: 2,
											}}
										>
											{asset.count}
										</div>
										<div
											style={{
												fontSize: 12,
												color: "#6b7280",
											}}
										>
											Asset(s)
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
